// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "assistant_whatsapp_link".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "assistant_whatsapp_link" table (1:1 with a DB row, on the wire). */
export const assistantWhatsappLinkAtomSchema = z.object({
    id: z.string(),
    userId: z.string(),
    organizationId: z.string(),
    phoneE164: z.string().nullable(),
    verificationCode: z.string().nullable(),
    codeExpiresAt: z.string().datetime().nullable(),
    status: z.string(),
    verifiedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=assistantWhatsappLink.js.map